module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAw0lEQVQ4ja1T7QnDIBQ8S4aokAxU0Anys6UrOIJkiPzMBo5kSaeI5YW+YD6NtAfy/Middz4irLU3AC0AiTz0AO4Fkeu6lmVZZrG997LrupYEsshCiLFWVUVFFvFh0zTT3BizWjvnxrnWetq/ZOZew1obhmE4PQhciTuLwBZT+GuEmQOlVJLAXTh0QFF4xHuEEEJaYOmGyVtvtCsQf8xiWxFPOViuKQZH+bkLJNB77zdvO+rKl/OmNj7orwJwzbz8BeD5ASfrf37mlyQQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/edit_popup_ico.png
// module id = UnID
// module chunks = 1